export const errors = {
    field_required: 'To pole jest wymagane',
    incorrect_email: 'Niepoprawny adres e-mail',
    incorrect_phone: 'Niepoprawny numer telefonu',
    incorrect_postcode: 'Niepoprawny kod pocztowy',
    passwords_must_match: 'Hasła muszą się zgadzać',
    check_required: 'Musisz zaznaczyć to pole',
    min_chars: (chars: number) => `Wymagane min. ${chars} znaków`
}